/* eslint-disable  react/prop-types */

import React from 'react';

const DuoCheckIcon = ({ width = 56, height = 56, style = {} }) => (
  <svg
    style={style}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="28" cy="28" r="24" stroke="#00619E" strokeWidth="2" />
    <path
      d="M18 30.127 24.6 37 40 19"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DuoCheckIcon;
